<div id="portal-copyright">
    <div>
        {{copyrightText}}
    </div>
    <div>
        <img src="../../../../assets/images/OrgLogo.png" alt="{{copyrightText}}">
    </div>
</div>
